import React from 'react';

// type === 'ripple' || 'flash-in-out'
const HighlightedText = ({
  text = '',
  type = 'ripple',
  containerClassName = '',
  textClassName = ''
}) => {
  // Split text into words
  const words = text.split(/(\s+)/);
  let charIndex = 0;
  switch (type) {
    case 'flash-in-out':
      return (
        <div className={' ' + containerClassName}>
          <span className={'animate-appear-in-out ' + textClassName}>
            {text}
          </span>
        </div>
      );
    case 'ripple':
    default:
      return (
        <span
          className="flex flex-wrap justify-center items-center leading-none w-full text-center"
          style={{
            wordBreak: 'break-word',
            whiteSpace: 'normal'
          }}
        >
          {words.map((word, wi) => {
            if (/^\s+$/.test(word)) {
              // Render whitespace as-is
              return <span key={`space-${wi}`}>{'\u00A0'}</span>;
            }
            // Render each word as a group, so no breaks in middle
            const chars = word.split('');
            const wordSpan = (
              <span
                key={`word-${wi}`}
                style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
              >
                {chars.map((char, ci) => {
                  const idx = charIndex++;
                  return (
                    <span
                      key={idx}
                      className="inline-block origin-center animate-flash-scale align-middle"
                      style={{
                        animationDelay: `${idx * 0.08}s`,
                        transformOrigin: 'center',
                        lineHeight: 1,
                        verticalAlign: 'middle',
                        display: 'inline-block'
                      }}
                    >
                      {char}
                    </span>
                  );
                })}
              </span>
            );
            return wordSpan;
          })}
        </span>
      );
  }
};

export default HighlightedText;
